import { components } from "react-select";
import { withClassName } from "../helpers";
export var GenericSelectControlValueContainer = withClassName(components.ValueContainer, "valueContainer");